import { Component, OnInit } from '@angular/core';

//Services
import { HttpClient, HttpResponse } from '@angular/common/http';
import { IScoreCard } from '../../interfaces/score-card';

@Component({
  selector: 'page-score-cards',
  templateUrl: 'score-cards.component.html',
  styleUrls: ['./score-cards.component.scss'],
})
export class ScoreCardsComponent {
  constructor(public http: HttpClient) {}
  Complains: any[] = [];
  ngOnInit() {
    this.getComplainsOptions();
  }

  getComplainsOptions() {
    this.http
      .get<any>('api/scorecards/getcomplainslist')
      .toPromise()
      .then((res) => {
        let body = {} as any;
        try {
          body = res;
          this.Complains = res;
        } catch (e) {}

        console.log(this.Complains);
      })
      .catch();
  }

  rateobj: IScoreCard = {
    Rate: 0,
    ScoreCardComplainIds: [],
    Feedback: '',
  };

  Supplier: string = 'Auto Move Co.';
  RightWrong: string = 'What went right';

  save() {
    console.log(this.rateobj);
    this.http
      .post<any>('api/scorecards/save', this.rateobj)
      .toPromise()
      .then((res) => {
        let body = {} as any;
        try {
          body = res;
        } catch (e) {}

        console.log(body);
      })
      .catch();
  }

  rate(e: any, num: number) {
    $('.vme-star').each(function () {
      $(this).removeClass('star-rate-card-on');
    });
    let rate = $(e.target);

    $('.vme-star').each(function (index, value) {
      if (index < num) $(this).addClass('star-rate-card-on');
    });
    if (num > 2) this.RightWrong = 'What went right';
    else this.RightWrong = 'What could be improved';

    this.rateobj.Rate = num;
  }

  selectWrongOption(e: any) {
    let wrongopt = $(e.target);
    let id = wrongopt.attr('id');
    id = id.replace('complain_', '');

    if (wrongopt.hasClass('rate-card-off')) {
      wrongopt.removeClass('rate-card-off');
      wrongopt.addClass('rate-card-on');
    } else {
      wrongopt.addClass('rate-card-off');
      wrongopt.removeClass('rate-card-on');
    }
    let existVal = this.rateobj.ScoreCardComplainIds.findIndex((x) => x == parseInt(id));

    if (existVal < 0) {
      this.rateobj.ScoreCardComplainIds.push(parseInt(id));
    } else {
      this.rateobj.ScoreCardComplainIds.splice(existVal, 1);
    }
  }
}
